<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addDisplay" v-if="permissionCodes.indexOf('004003001') !== -1"/>
      </div>
      <input-search placeholder="设备名称/设备编号" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @goToModifyPage="goToModifyPage" @deleteLine="deleteLine" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "display-manage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "显示屏管理"
        }
      ],
      addDisplay: "display-add",
      tableHead: [
        {
          prop: "displayName",
          label: "显示屏名称"
        },
        {
          prop: "displayType",
          label: "显示屏类型"
        },
        {
          prop: "applicationScenario",
          label: "应用场景"
        },
        {
          prop: "deviceName",
          label: "关联相机"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: ""
      },
      operationArr: ["modify", "delete"]
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    // 获取设备
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getDisplayPage, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            v.code = v.displayCode;
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取显示屏失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },

    goToModifyPage(code) {
      this.$router.push({
        path: `/park_server/display_modify/${code}`
      });
    },
    deleteLine(code) {
      let codes = code.join(",");
      this.$axios
        .post(api.deleteDisplayByCode, { displayCode: codes })
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/Display/DisplayManage.vue